var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 16",
    style: {
      enableBackground: "new 0 0 20 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5A623;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cuore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OS_Head",
    transform: "translate(-662.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cuore",
    className: "st0",
    d: "M672,43c0-1.4-0.5-2.6-1.5-3.5c-1-1-2.2-1.5-3.6-1.5c-1.4,0-2.6,0.5-3.5,1.5 c-1,1-1.5,2.1-1.5,3.5c0,2,0.7,3.7,2,5l8,6c4.1-2.8,6.8-4.8,8-6c1.3-1.3,2-3,2-5c0-1.4-0.5-2.6-1.5-3.5c-1-1-2.1-1.5-3.5-1.5 c-1.4,0-2.6,0.5-3.5,1.5C672.5,40.4,672,41.6,672,43z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOrange);
export default __webpack_public_path__ + "static/media/heart-orange.4b2c737d599a59aba2d79858365355ad.svg";
export { ForwardRef as ReactComponent };